import * as fromNews from './news.selector';
import * as fromEvents from './events.selector';
import * as fromBlogs from '../../../blogs/store/selectors/blogs.selector';
import * as fromContentPages from './content-pages.selector';

import { EventsState } from '../reducers/events.reducer';
import { NewsState } from '../reducers/news.reducer';
import { createSelector } from '@ngrx/store';
import { ContentPagesState } from '../reducers/content-pages.reducer';
import * as fromRoot from '../../../store';
import * as fromFeature from '../reducers';
import { getContentPageEntities, getContentPageState } from './content-pages.selector';
import { BlogsState } from '../../../blogs/store/reducers/blogs.reducer';
import { ContentPage, News, Event } from '../../models';
import { Blog } from '../../../blogs/models';

// export const getContentPageState = createSelector(fromFeature.getContentState, (state: fromFeature.ContentState) => state.contentPages);

// export const getContentPageEntities = createSelector(getContentPageState, fromContentPages.getContentPagesEntities);

export const getSelectedContent = createSelector(
  fromEvents.getEventsOverviewEntities,
  fromNews.getNewsOverviewEntities,
  fromContentPages.getContentPageEntities,
  fromBlogs.getBlogsOverviewEntities,
  fromRoot.getRouterState,
  (events, news, contentPages, blogs, router): Event | News | ContentPage | Blog => {
    const contentType: string = router.state.params['contentType'] || router.state.data['contentType'];

    const content: { [key: string]: { [id: number]: Event | News | ContentPage | Blog } } = {
      nieuws: { ...news },
      evenementen: { ...events },
      pagina: { ...contentPages },
      blogs: { ...blogs },
    };

    // console.log(
    //   contentType,
    //   content,
    //   router.state.params?.pageId || router.state.data?.pageId,
    //   router.state && content[contentType] && content[contentType][router.state.params?.pageId || router.state.data?.pageId]
    // );

    return router.state && content[contentType] && content[contentType][router.state.params?.['pageId'] || router.state.data?.['pageId']];
  }
);

export const getSelectedContentLoaded = createSelector(getSelectedContent, content => {
  return content && content.loaded;
});

export const getSelectedOverview = createSelector(
  fromEvents.getEventState,
  fromNews.getNewsState,
  fromBlogs.getBlogState,
  getContentPageState,
  fromRoot.getRouterState,
  (events, news, blogs, contentPages, router): EventsState | NewsState | BlogsState | ContentPagesState | null => {
    if (!router.state) {
      return null;
    }
    const contentType: string = router.state.params['contentType'] || router.state.data['contentType'];
    const content: { [key: string]: EventsState | NewsState | BlogsState | ContentPagesState } = {
      nieuws: news,
      blogs,
      evenementen: events,
      pagina: contentPages,
    };

    return content[contentType];
  }
);

export const getSelectedOverviewItems = createSelector(getSelectedOverview, content => {
  if (!content) {
    return [];
  }
  return Object.keys(content.overview).map(id => content.overview[+id]);
});

export const getSelectedOverviewItemsOrdered = createSelector(getSelectedOverviewItems, fromRoot.getRouterState, (items, router) => {
  const contentType: string = router.state.params['contentType'] || router.state.data['contentType'];
  if (contentType === 'nieuws') {
    return (items as News[]).sort((a, b) => (new Date(b.publishDate) > new Date(a.publishDate) ? 1 : -1));
  } else if (contentType === 'evenementen') {
    return (items as Event[]).sort((a, b) => (new Date(b.publishDate) < new Date(a.publishDate) ? 1 : -1));
  } else if (contentType === 'blogs') {
    return (items as Blog[]).sort((a, b) => (new Date(b.publishDate) > new Date(a.publishDate) ? 1 : -1));
  }
  return (items as ContentPage[]).sort((a, b) => +b.order - +a.order);
});

export const getSelectedOverviewLoaded = createSelector(getSelectedOverview, content => {
  return content?.overviewLoaded;
});

export const getSelectedOverviewPage = createSelector(getSelectedOverview, content => {
  return content?.page;
});
